import React from 'react';
import { useSlideData } from '@context/slide-data';
import { SectionOne } from './SectionOne';
import { SectionTwo } from './SectionTwo';
import { SectionThree } from './SectionThree';

export const YourAnalysisScript = () => {
    const { slideState, data } = useSlideData();
    const { id, details } = data;
    const { selectedSection } = slideState;

    const sections = {
        1: <SectionOne details={details}/>,
        2: <SectionTwo details={details} />,
        3: <SectionThree details={details}/>
    };

    return sections[selectedSection[id]];
};

export default YourAnalysisScript;
